import { render, staticRenderFns } from "./DesativarItem.vue?vue&type=template&id=152692c6&scoped=true&lang=pug"
import script from "./DesativarItem.vue?vue&type=script&lang=js"
export * from "./DesativarItem.vue?vue&type=script&lang=js"
import style0 from "./DesativarItem.vue?vue&type=style&index=0&id=152692c6&prod&lang=scss&scoped=true"
import style1 from "./DesativarItem.vue?vue&type=style&index=1&id=152692c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152692c6",
  null
  
)

export default component.exports